module.exports = __webpack_public_path__ + "img/tent004.c537a09a.jpg";